import React from 'react';
import PropTypes from 'prop-types';

import Align from '@marvelapp/marvel-ui/align';
import Grid, { GridItem } from '@marvelapp/marvel-ui/grid';
import MaxWidth from '@marvelapp/marvel-ui/max-width';
import Spacing from '@marvelapp/marvel-ui/spacing';

import Feature from 'marketing-website/components/modules/Feature';
import HeadingBlock from 'marketing-website/components/modules/HeadingBlock';
import MediaFeature from 'marketing-website/components/modules/Media/MediaFeature';

import downloadIcon from 'marketing-website/components/icons/Download';
import mobileIcon from 'marketing-website/components/icons/Mobile';
import usersIcon from 'marketing-website/components/icons/Users';

import assets from 'marketing-website/configs/pages/features/design/assets.js';
import styles from './style/interfacesBlock.module.css';

export default function InterfacesBlock({ color }) {
  return (
    <Spacing type="padding" size="xl" position="topBottom">
      <div className={styles.withBorder}>
        <Spacing type="padding" size="m" sizeM="0" position="leftRight">
          <Spacing type="padding" size="l" sizeM="0" position="bottom">
            <Align type="center">
              <HeadingBlock
                alignContent="center"
                alignM="center"
                maxWidth={460}
                copy={
                  <span>
                    Marvel puts the power of design in everyones hands, leading
                    to better ideas, innovation and culture.
                    <br />
                    <br />
                    We’ve crafted intuitive design tools that mean new users can
                    onboard in minutes, making it easy for anyone to jump in and
                    collaborate on designs.
                  </span>
                }
                title="Democratise design across your business"
              />
            </Align>
          </Spacing>
        </Spacing>
      </div>

      <MediaFeature
        {...assets.canvas}
        backgroundColor={color}
        patternLeft="34.5%"
        patternTop="46%"
        patternColor="yellow"
      >
        <Grid columns={12} alignContent="space-around">
          <GridItem columnSpan={12} columnSpanS={4} columnSpanM={12}>
            <Align type="center" typeM="left">
              <MaxWidth value={300}>
                <Spacing type="padding" size="xs" position="topBottom">
                  <Feature
                    type="icon"
                    icon={usersIcon}
                    backgroundColor={color}
                    fontWeight="semibold"
                    copy="Remix ideas and make your own changes to designs uploaded by your team from Sketch"
                    title="Open and edit Sketch designs (Beta)"
                  />
                </Spacing>
              </MaxWidth>
            </Align>
          </GridItem>
          <GridItem columnSpan={12} columnSpanS={4} columnSpanM={12}>
            <Align type="center" typeM="left">
              <MaxWidth value={340}>
                <Spacing type="padding" size="xs" position="topBottom">
                  <Feature
                    type="icon"
                    icon={downloadIcon}
                    backgroundColor={color}
                    fontWeight="semibold"
                    copy=" Improve brand consistency across your products, marketing and more through sharing your brand assets and UI kits company wide"
                    title="Team Libraries"
                  />
                </Spacing>
              </MaxWidth>
            </Align>
          </GridItem>
          <GridItem columnSpan={12} columnSpanS={4} columnSpanM={12}>
            <Align type="center" typeM="left">
              <MaxWidth value={340}>
                <Spacing type="padding" size="xs" position="topBottom">
                  <Feature
                    type="icon"
                    icon={mobileIcon}
                    backgroundColor={color}
                    fontWeight="semibold"
                    copy="All your designs are saved within Marvel on the cloud, so you can open up your work from any device. No files or fuss."
                    title="Access work anywhere"
                  />
                </Spacing>
              </MaxWidth>
            </Align>
          </GridItem>
        </Grid>
      </MediaFeature>
    </Spacing>
  );
}

InterfacesBlock.propTypes = {
  color: PropTypes.string,
};

InterfacesBlock.defaultProps = {
  color: null,
};



// WEBPACK FOOTER //
// ./src/pages/features/design/InterfacesBlock.js